export const HIDE_FOR_ADMIN = ['applications'];